import { Component } from '@angular/core';

@Component({
  selector: 'app-row-action-dropdown',
  templateUrl: './row-action-dropdown.component.html',
  styleUrls: ['./row-action-dropdown.component.scss'],
})
export class RowActionDropdownComponent {}
